<template>
  <v-dialog v-model="dialog" persistent max-width="500" scrollable>
    <template v-slot:activator="{ on }">
      <v-btn text class="link-button" v-on="on" id="cookiepolicy">{{ $t('cookie.information_footer_link_cookiepolicy') }}</v-btn>
    </template>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{ $t('cookie.change_header') }}</v-card-title>
      <v-card-text>
        <v-list subheader two-line flat>
           <v-list-item>{{ $t('cookie.change_intro') }}</v-list-item>


            <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="userConsent.necessary" switch="switchNecessary" :switchNecessary="userConsent.Necessary"></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('cookie.change_neccessary_title') }}</v-list-item-title>
                  <p>{{ $t('cookie.change_neccessary_text') }}</p>
                </v-list-item-content>
            </v-list-item>

            <v-list-item id="itemAnalytics" :switchAnalytics="userConsent.analytics">
                <v-list-item-action>
                  <v-switch v-model="userConsent.analytics" class="switchAnalytics"></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('cookie.change_analytics_title') }}</v-list-item-title>
                  <p>{{ $t('cookie.change_analytics_text') }}</p>
                </v-list-item-content>
            </v-list-item>


            <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="userConsent.marketing" switch="switchMarketing" :switchMarketing="userConsent.marketing"></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('cookie.change_marketing_title') }}</v-list-item-title>
                  <p>{{ $t('cookie.change_marketing_text') }}</p>
                </v-list-item-content>
            </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="saveSettings()" id="saveCookieSettings">{{ $t('cookie.save_changes') }}</v-btn>
        <v-btn color="primary" text @click="dialog = false">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.link-button {
  font-weight: bold;
  text-decoration: underline;
  padding-left: 0px !important;
}
</style>

<script>
export default {
  data() {
    return {
      dialog: false,
      userConsent: { necessary: "true", analytics: "true", marketing: "true" }
    };
  },
  methods:{
      saveSettings: function()
      {
          this.$store.dispatch("changeCookiePreference", this.userConsent);
          this.dialog = false;
      }
  }
};
</script>
